export enum AppRoute {
  // public routes
  PUBLIC_DESIGN_SYSTEM = "/public-design-system",
  PUBLIC_DESIGN_SYSTEM_DIRECT_ASSEMBLE_SYSTEM = "/public-design-system/direct/assemble-system",
  PUBLIC_DESIGN_SYSTEM_DIRECT_SYSTEM_SUMMARY = "/public-design-system/direct/system-summary",
  PUBLIC_DESIGN_SYSTEM_SIMPLIFIED_USAGE_INFO = "/public-design-system/simplified/usage-info",
  PUBLIC_DESIGN_SYSTEM_SIMPLIFIED_ASSEMBLE_SYSTEM = "/public-design-system/simplified/assemble-system",
  PUBLIC_DESIGN_SYSTEM_SIMPLIFIED_SYSTEM_SUMMARY = "/public-design-system/simplified/system-summary",
  PUBLIC_DESIGN_SYSTEM_WATER_HEATER_ASSEMBLE_SYSTEM = "/public-design-system/water-heater/assemble-system",
  PUBLIC_DESIGN_SYSTEM_WATER_HEATER_SYSTEM_SUMMARY = "/public-design-system/water-heater/system-summary",
  PUBLIC_DESIGN_SYSTEM_SETTINGS = "/public-design-system/settings",
  LOGIN = "/login",
  FORGOT_PASSWORD = "/forgot_password",
  RESET_PASSWORD = "/reset_password",
  CHANGE_EMAIL = "/change_email",
  EMAIL_VERIFICATION = "/email_verification",
  REGISTER = "/register",

  // dashboard routes
  DASHBOARD = "/dashboard",
  HOME = "/dashboard/home",
  SITES = "/dashboard/sites",
  ESTIMATIONS = "/dashboard/estimations",
  EDIT_ESTIMATIONS = "/dashboard/estimations/edit",
  DESIGN_SYSTEM = "/dashboard/design-system",
  DESIGN_SYSTEM_ADVANCED_DEVICES = "/dashboard/design-system/advanced/devices",
  DESIGN_SYSTEM_ADVANCED_USAGE_INFO = "/dashboard/design-system/advanced/usage-info",
  DESIGN_SYSTEM_ADVANCED_ASSEMBLE_SYSTEM = "/dashboard/design-system/advanced/assemble-system",
  DESIGN_SYSTEM_ADVANCED_SYSTEM_SUMMARY = "/dashboard/design-system/advanced/system-summary",
  DESIGN_SYSTEM_SIMPLIFIED_USAGE_INFO = "/dashboard/design-system/simplified/usage-info",
  DESIGN_SYSTEM_SIMPLIFIED_ASSEMBLE_SYSTEM = "/dashboard/design-system/simplified/assemble-system",
  DESIGN_SYSTEM_SIMPLIFIED_SYSTEM_SUMMARY = "/dashboard/design-system/simplified/system-summary",
  DESIGN_SYSTEM_DIRECT_ASSEMBLE_SYSTEM = "/dashboard/design-system/direct/assemble-system",
  DESIGN_SYSTEM_DIRECT_SYSTEM_SUMMARY = "/dashboard/design-system/direct/system-summary",
  DESIGN_SYSTEM_WATER_HEATER_ASSEMBLE_SYSTEM = "/dashboard/design-system/water-heater/assemble-system",
  DESIGN_SYSTEM_WATER_HEATER_SYSTEM_SUMMARY = "/dashboard/design-system/water-heater/system-summary",
  USAGE = "/dashboard/usage",
  SCHEDULE = "/dashboard/schedule",
  LIFE_LINE_POWER = "/dashboard/life-line-power",
  LIFE_LINE_POWER_PLANNED = "/dashboard/life-line-power-planned",
  LIFE_LINE_POWER_UNPLANNED = "/dashboard/life-line-power-unplanned",
  LIFE_LINE_POWER_UNPLANNED_CONTRACTS = "/dashboard/life-line-power-unplanned/contracts",
  LIFE_LINE_POWER_UNPLANNED_BILL = "/dashboard/life-line-power-unplanned/bill",
  LIFE_LINE_POWER_UNPLANNED_PURCHASE_HISTORY = "/dashboard/life-line-power-unplanned/purchase-history",
  ADD_SCHEDULE = "/dashboard/schedule/add",
  EDIT_SCHEDULE = "/dashboard/schedule/edit",
  CONTROLLERS = "/dashboard/controllers",
  ADD_CONTROLLER = "/dashboard/controllers/add-controller",
  EDIT_CONTROLLER = "/dashboard/controllers/edit-controller",
  BILL_CALCULATOR = "/dashboard/bill-calculator",
  ADD_BILL_CALCULATOR = "/dashboard/bill-calculator/add",
  EDIT_BILL_CALCULATOR = "/dashboard/bill-calculator/edit",
  SPACE_CLUSTERS = "/dashboard/space-clusters",
  SOLAR = "/dashboard/generation/solar",
  BATTERY = "/dashboard/generation/battery",
  GENERATION = "/dashboard/generation",
  LIMITATION_USAGE_GUIDE = "/dashboard/limitation-usage-guide",
  VIEW_DEMAND_RESPONSE_PROGRAM = "/dashboard/limitation-usage-guide/view-demand-response-program",
  JOIN_DEMAND_RESPONSE_PROGRAM = "/dashboard/limitation-usage-guide/join-demand-response-program",
  EDIT_DEMAND_RESPONSE_PROGRAM = "/dashboard/limitation-usage-guide/edit-demand-response-program",
  SETTINGS = "/dashboard/settings",
  METER_DASHBOARD = "/dashboard/usage/meter-dashboard",
  ENERGY_USAGE = "/dashboard/energy-usage",
  HIGHEST_POWER_CONSUMPTION = "/dashboard/usage/devices-with-highest-power-consumption",
  NOT_FOUND = "/dashboard/*",
  USER_PROFILE = "/dashboard/user-profile",
  VERIFY_EMAIL_OTP = "/verify-email-otp",
  CHANGE_MOBILE_NUMBER = "/change-mobile-number",
  VERIFY_EMAIL = "/verify-email",
  CHANGE_PASSWORD = "/change-password",
  USER_EMAIL_VERIFICATION = "/user_email_verification",
  MANAGE = "/dashboard/manage",
  // admin routes
  ADMIN = "/",
  ADMIN_LOGIN = "/login",
  ADMIN_DASHBOARD = "/dashboard",
  ADMIN_SITES_OLD = "/sites-old",
  ADMIN_SITES = "/sites",
  ADMIN_SITES_ERROR_LOG = "/sites/error-log",
  ADMIN_ESTIMATIONS = "/estimations",
  ADMIN_POWER_LIMIT = "/power-limit",
  ADMIN_POWER_LIMIT_VIEW_CONTROL_COMMAND = "/power-limit/view-control-command",
  ADMIN_POWER_LIMIT_ADD_NEW_COMMAND = "/power-limit/add-new-command",
  ADMIN_POWER_LIMIT_EDIT_COMMAND = "/power-limit/edit-command",
  ADMIN_POWER_LIMIT_VIEW_SITE = "/power-limit/view-site",
  ADMIN_BLACKOUT = "/blackout",
  ADMIN_SOLAR_DASHBOARD = "/solar-dashboard",
  ADMIN_BATTERY_DASHBOARD = "/battery-dashboard",
  ADMIN_USERS = "/users",
  ADMIN_SOLAR_PLANTS = "/solar_plants",
  ADMIN_SOLAR = "/solar",
  ADMIN_CONTROLLERS = "/controllers",
  ADMIN_USAGE_GUIDE = "/usage-guide",
  ADMIN_DEMAND_RESPONSE_PROGRAM = "/usage-guide/demand-response-program-view",
  AUTOMATED_DEMAND_CONTROL = "/usage-guide/automated-demand-control-request",
  ADD_MANUAL_DEMAND_CONTROL = "/usage-guide/manual-demand-control-request",
  REQUESTS = "/usage-guide/requests",
  ADD_LIMITATION = "/usage-guide/add-limitation",
  EDIT_LIMITATION = "/usage-guide/edit-limitation",
  ADMIN_LIFE_LINE_POWER = "/life-line-power",
  ADMIN_LIFE_LINE_POWER_UNPLANNED = "/life-line-power/unplanned",
  ADMIN_LIFE_LINE_POWER_UNPLANNED_VIEW = "/life-line-power/unplanned/view",
  ADMIN_SETTINGS = "/settings",
  ADMIN_PROFILE = "/profile",
  ADMIN_NOT_FOUND = "/*",

  UNAUTHORIZED = "/unauthorized",
}
